<script>
import PendingRequisitionLink from './PendingRequisitionLink.vue';
import moment from 'moment'
export default {
    components: {
        PendingRequisitionLink
    },

    props: {
        user: {
            type: Object,
            required: true
        },
        defaultRequisitions: {
            type: Array,
            required: true
        },
        companies: {
            type: Array,
            required: true
        },
        users: {
            type: Array,
            required: true
        }
    },

    computed: {
        filteredRequisitions() {
            return this.requisitions
                .filter(req => {
                    const personSpec = req.person_specification;
                    if (personSpec && personSpec.business_line && personSpec.business_line.company && personSpec.business_line.company.title) {
                        return (
                            personSpec.business_line.company.title.toLowerCase().includes(this.textFilter.toLowerCase()) ||
                            personSpec.title.toLowerCase().includes(this.textFilter.toLowerCase())
                        );
                    }
                    return false;
                })
                .filter(req => this.recruiterIdFilter === null || req.creator_id === this.recruiterIdFilter)
                .filter(req => this.companyIdFilter === null || req.person_specification.business_line.company_id === this.companyIdFilter)
                .filter(req => {
                    if(this.requisitionStatus == 'expired') return (req.closing_date < moment().format('YYYY-MM-DD hh:mm::ss'))
                    else if(this.requisitionStatus == 'pending') return req.closing_date > moment().format('YYYY-MM-DD hh:mm::ss')
                    else return true
                })
                       
        },
        createdRequisitions() {
            return this.filteredRequisitions.filter(req => req.current_status === 'created');
        },
        firstApprovalRequisitions() {
            return this.filteredRequisitions.filter(req => req.current_status === 'first_approval');
        },
        secondApprovalRequisitions() {
            return this.filteredRequisitions.filter(req => req.current_status === 'second_approval');
        },
        thirdApprovalRequisitions() {
            return this.filteredRequisitions.filter(req => ['third_approval', 'to_publish'].includes(req.current_status));
        },
        adCreationRequisitions() {
            return this.filteredRequisitions.filter(req => req.current_status === 'ad_creation');
        },
        adApprovalRequisitions() {
            return this.filteredRequisitions.filter(req => req.current_status === 'ad_approval');
        },
        approvedRequisitions() {
            return this.filteredRequisitions.filter(req => req.current_status === 'published');
        },
    },

    data() {
        return {
            requisitions: [...this.defaultRequisitions],
            textFilter: '',
            recruiterIdFilter: null,
            companyIdFilter: null,
            requisitionStatuses: [
                { id: "expired", title: "Expired" },
                { id: "pending", title: "Pending" },
            ],
            requisitionStatus: 'pending'
        }
    },

    methods: {
    }
}
</script>

<template>
    <div class="requisitions-table grid-x grid-padding-x grid-padding-y">
            <div class="cell medium-12 filter-by">
                Filter by
            </div>
        <div class="cell auto">
            <div class="grid-x grid-padding-x select-filter-container">
                <div class="cell medium-3">
                <select v-model="requisitionStatus">
                    <option :value="null">Status</option>
                        <option v-for="status in requisitionStatuses" :value="status.id" :key="status.id">
                            {{ status.title }}
                        </option>
                    </select>
                </div>
                <div class="cell medium-4">
                    <select v-model="recruiterIdFilter">
                        <option :value="null">Recruiter</option>
                        <option v-for="user in users" :value="user.id" :key="user.id">
                            {{ user.full_name }}
                        </option>
                    </select>
                </div>

                <div class="cell medium-4">
                    <select v-model="companyIdFilter">
                        <option :value="null">Business Unit</option>
                        <option v-for="company in companies" :value="company.id" :key="company.id">
                            {{ company.title }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="cell shrink search-container">
            <input type="text" v-model="textFilter" placeholder="Search (Title)" class="mb-0 search-input" />
            <li class="fas fa-search search-icon"></li>
        </div>

        <div class="cell small-12 pt-1">
            <table class="mb-4">
                <thead>
                    <tr>
                        <th>Created</th>
                        <th>1st Approval</th>
                        <th>2nd Approval</th>
                        <th>Final Approval</th>
                        <th>Ad Creation</th>
                        <th>Ad Approval</th>
                        <th>Approved</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>
                            <pending-requisition-link
                                v-for="(requisition, i) in createdRequisitions" :key="requisition.id"
                                :requisition="requisition" :user="user" :class="i == (filteredRequisitions.length - 1) ? 'mb-0' : 'mb-4'"
                            />
                        </td>
                        <td>
                            <pending-requisition-link
                                v-for="(requisition, i) in firstApprovalRequisitions" :key="requisition.id"
                                :requisition="requisition" :user="user" :class="i == (filteredRequisitions.length - 1) ? 'mb-0' : 'mb-4'"
                            />
                        </td>
                        <td>
                            <pending-requisition-link
                                v-for="(requisition, i) in secondApprovalRequisitions" :key="requisition.id"
                                :requisition="requisition" :user="user" :class="i == (filteredRequisitions.length - 1) ? 'mb-0' : 'mb-4'"
                            />
                        </td>
                        <td>
                            <pending-requisition-link
                                v-for="(requisition, i) in thirdApprovalRequisitions" :key="requisition.id"
                                :requisition="requisition" :user="user" :class="i == (filteredRequisitions.length - 1) ? 'mb-0' : 'mb-4'"
                            />
                        </td>
                        <td>
                            <pending-requisition-link
                                v-for="(requisition, i) in adCreationRequisitions" :key="requisition.id"
                                :requisition="requisition" :user="user" :class="i == (filteredRequisitions.length - 1) ? 'mb-0' : 'mb-4'"
                            />
                        </td>
                        <td>
                            <pending-requisition-link
                                v-for="(requisition, i) in adApprovalRequisitions" :key="requisition.id"
                                :requisition="requisition" :user="user" :class="i == (filteredRequisitions.length - 1) ? 'mb-0' : 'mb-4'"
                            />
                        </td>
                        <td>
                            <pending-requisition-link
                                v-for="(requisition, i) in approvedRequisitions" :key="requisition.id"
                                :requisition="requisition" :user="user" :class="i == (filteredRequisitions.length - 1) ? 'mb-0' : 'mb-4'"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <p class="text-center">{{ requisitions.length }} requisition(s)</p>
    </div>
</template>

<style lang="scss">
.requisitions-table {
    .filter-by {
        font-weight: 700;
        font-size: 12px;
        padding-bottom: 0;
        margin-bottom: -8px;
    }

    .font-bold {
        font-weight: bold;
    }

    .mb-0 {
        margin-bottom: 0;
    }

    .mb-1 {
        margin-bottom: 0.25rem;
    }

    p.text-center {
        width: 100%;
        text-align: center;
    }

    .select-filter-container {
        select {
            border: 1px solid #D1D1D1;
            font-size: 13px;
            height: 40px;
            padding: 1px 28px 0 15px;
            -webkit-appearance: none;
            -moz-appearance: none;
            background: url(/img/down-arrow.png) #ffffff;
            background-repeat: no-repeat;
            background-position: 97% 50%;
            background-size: 13px 8px;
        }
    }

    .search-container {
        position: relative;
        display: block;

        .search-input {
            border: 1px solid #D1D1D1;
            font-size: 13px;
            height: 40px;
            padding: 1px 28px 0 15px;
            width: 250px;
            border-radius: 0;

            &::placeholder {
                font-style: italic;
            }
        }

        .search-icon {
            position: absolute;
            font-size: 14px;
            right: 22px;
            top: 24px;
        }
    }

    table {
        border: 1px solid #D1D1D1;

        thead {
            background-color: #EBEBEB;

            th {
                padding-top: 1rem;
                padding-bottom: 1rem;
                text-align: center;
                border-left: 1px solid #D1D1D1;
                color: #455666;
                font-size: 14px;
            }
        }

        tbody {
            td {
                width: 14.285%;
                vertical-align: top;
                border-left: 1px solid #D1D1D1;
            }
        }
    }
}
</style>